import type { IDendrogram } from "../../../types/models/dendrogram"
import { getServerUrl } from "../pages/utils/fetchConfigClient"

export type {
  IBranchProfile,
  IClusterProfile,
  IDendrogram,
  IDendrogramNode
} from "../../../types/models/dendrogram"

export async function fetchDendrogram(): Promise<IDendrogram | null> {
  return fetch(getServerUrl("/dendrogram")).then((res) => res.json())
}
